<div style="width: 300px;">
    <clr-toggle-container>
        <label>Filter table values that match these values:</label>
    </clr-toggle-container>

  <button class="label label-blue" style="cursor: pointer;" (click)="checkAll()">check all</button>
  <button class="label label-blue" style="cursor: pointer;" (click)="uncheckAll()">uncheck all</button>

  <div style="max-height: 500px; overflow: scroll;">
    <clr-checkbox-container clrInline>
    @for (valueItem of valueItems; track valueItem.key) {
      <clr-checkbox-wrapper>
        <input type="checkbox" clrCheckbox name="{{ valueItem.key }}" value="{{ valueItem.key }}" [(ngModel)]="filteredValues[valueItem.key]" (change)="resourceSelectionChanged($event)"/>
        <label>{{ valueItem.label }}</label>
      </clr-checkbox-wrapper>
    }
    </clr-checkbox-container>
  </div>
</div>
